import SectionHead from '@/components/SectionHead';
import RegistrationForm from '@/components/RegistrationForm';
import { motion } from 'framer-motion';
import { ShieldCheck, Timer, Users } from 'lucide-react';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

const ASSURANCES = [
  { icon: ShieldCheck, text: 'Safe, positive and professional environment for every player' },
  { icon: Timer, text: 'We reply fast — usually the same day via WhatsApp or phone' },
  { icon: Users, text: 'Boys and girls ages 5–16, all experience levels welcome' },
];

export default function RegisterSection() {
  return (
    <section id="register" className="relative py-24 sm:py-32 bg-night border-t border-white/5 overflow-hidden" data-testid="register-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(197,160,89,0.07),transparent_55%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="14"
          eyebrow="Registration"
          title={'START YOUR\nJOURNEY.'}
          description="Two minutes is all it takes. Tell us about your player and the ASA coaching team will reach out with the next steps."
          testId="register-heading"
        />
        <div className="grid lg:grid-cols-5 gap-10 items-start">
          <motion.div
            variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
            className="lg:col-span-2 space-y-5"
          >
            {ASSURANCES.map((a, i) => (
              <motion.div key={i} variants={fadeUp} custom={i} className="flex items-start gap-4 glass-card rounded-sm p-5">
                <a.icon size={22} className="text-brand-gold shrink-0 mt-0.5" />
                <p className="text-sm sm:text-base text-gray-300 leading-relaxed">{a.text}</p>
              </motion.div>
            ))}
            <motion.div variants={fadeUp} custom={3} className="border-l-2 border-brand-red pl-5 py-1">
              <p className="text-sm text-gray-500 leading-relaxed">
                Prefer to talk first? Message us on WhatsApp at <span className="text-brand-gold font-semibold">734-353-8112</span> — we love meeting ASA families.
              </p>
            </motion.div>
          </motion.div>
          <motion.div variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-3">
            <RegistrationForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
